module.exports = __webpack_public_path__ + "static/img/li1_14.55f0ddb5.png";